import { InjectionToken } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface MuChatConfig {
  /** Must start with https:// and end with '/'. */
  widgetBaseUrl: string;
  /** Lowercase letters, digits and dashes. */
  slug: string;
  /** Iframe width in px. */
  width: number;
  /** Iframe height in px. */
  height: number;
}

export const MU_CHAT_DEFAULT_WIDTH = 376;
export const MU_CHAT_DEFAULT_HEIGHT = 540;

export const MU_CHAT_CONFIG = new InjectionToken<MuChatConfig>('MU_CHAT_CONFIG', {
  providedIn: 'root',
  factory: () => {
    const { widgetBaseUrl, slug, width, height } = environment.chat;
    return { widgetBaseUrl, slug, width, height };
  },
});
